import { useEffect } from "react";

export const SITE_URL = "https://www.30north.ca";

const DEFAULT_TITLE = "30 NORTH | Transportation & Logistics";
const DEFAULT_DESCRIPTION =
  "30 NORTH provides reliable transportation and logistics solutions for businesses across Canada, with flexible options built around your freight requirements.";

const setMeta = (selector, attr, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const match = selector.match(/\[(name|property)="(.+?)"\]/);
    if (match) el.setAttribute(match[1], match[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export function usePageMeta({ title, description, path, noindex = false }) {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    if (noindex) setMeta('meta[name="robots"]', "content", "noindex, nofollow");

    let canonical = document.querySelector('link[rel="canonical"]');
    if (path) {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", SITE_URL + path);
    } else if (canonical) {
      canonical.remove();
    }

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', "content", DEFAULT_DESCRIPTION);
      const robots = document.querySelector('meta[name="robots"]');
      if (robots) robots.remove();
    };
  }, [title, description, path, noindex]);
}
